/**
 * Standardized API Exception
 * 
 * Used to bubble up backend errors to the UI layer in a consistent format.
 */
export class ApiException extends Error {
    public code: string;
    public details?: any;
    public meta?: any;
    public status?: number;

    constructor(
        message: string,
        code: string,
        meta?: any,
        details?: any,
        status?: number
    ) {
        super(message);
        this.name = 'ApiException';
        this.code = code;
        this.meta = meta;
        this.details = details;
        this.status = status;

        // Restore prototype chain for instance checks
        Object.setPrototypeOf(this, ApiException.prototype);
    }
}
